import { motion } from "framer-motion";
import Swipertwo from "../components/Swipertwo";
import Swiperone from "../components/Swiperone";

export default function Solutions() {
  return (
    <section
      id="solutions"
      className="relative py-16 md:py-24 bg-[#0B0F19] overflow-hidden">
      <div className="absolute top-0 left-1/4 w-64 h-64 md:w-96 md:h-96 bg-blue-600/10 blur-[80px] md:blur-[120px] rounded-full" />
      <div className="absolute bottom-0 right-1/4 w-64 h-64 md:w-96 md:h-96 bg-emerald-500/10 blur-[80px] md:blur-[120px] rounded-full" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-12 md:mb-20 text-center">
          <h2 className="text-3xl sm:text-4xl md:text-6xl font-black text-white mb-3 md:mb-4 tracking-tighter uppercase italic px-2">
            Our Innovative <span className="text-[#018CF1]">Solutions</span>
          </h2>
          <div className="h-1 w-24 md:w-32 bg-gradient-to-r from-[#007BFF] to-[#05DFAD] mx-auto rounded-full" />
        </motion.div>

        <div className="space-y-12 md:space-y-20">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="bg-[#161B22]/60 backdrop-blur-xl p-6 md:p-8 lg:p-14 rounded-[20px] md:rounded-[40px] shadow-2xl border border-white/5 ring-1 ring-white/10">
            <Swipertwo />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="bg-[#161B22]/60 backdrop-blur-xl p-6 md:p-8 lg:p-14 rounded-[20px] md:rounded-[40px] shadow-2xl border border-white/5 ring-1 ring-white/10">
            <Swiperone />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
